// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__wpVrQ","info":"PatientInfo_info__1VJaH"};